import { Component } from "react";
import { connect } from "react-redux";
import { Dimensions, Platform } from "react-native";

import { deepUpdateComplete } from "state/modules/app/actions";

const isNative = Platform.OS !== "web";

class BaseDeepUpdater extends Component {
  state = { shouldRender: true };

  componentDidMount = () => {
    isNative && Dimensions.addEventListener("change", this.listener);
  };

  componentWillUnmount = () => {
    isNative && Dimensions.removeEventListener("change", this.listener);
  };

  componentDidUpdate = prevProps => {
    if (this.props.shouldDeepUpdate && !prevProps.shouldDeepUpdate) {
      this.deepUpdate();
    }
  };

  deepUpdate() {
    this.setState({ shouldRender: false }, () => {
      this.setState({ shouldRender: true });
      this.props.deepUpdateComplete();
    });
  }

  listener = () => this.deepUpdate();

  render = () => {
    if (!this.state.shouldRender) return null;
    return this.props.children;
  };
}

const mapDispatchToProps = {
  deepUpdateComplete,
};

const mapStateToProps = state => {
  return { shouldDeepUpdate: state.app.shouldDeepUpdate };
};

export const DeepUpdater = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseDeepUpdater);
